import {
  READY,
  SUCCESS,
} from '@/constants';

const UPLOAD_ADD = 'UPLOAD_ADD';
const UPLOAD_UPDATE = 'UPLOAD_UPDATE';
const UPLOAD_REMOVE = 'UPLOAD_REMOVE';
const UPLOAD_CLEAR = 'UPLOAD_CLEAR';
const UPLOAD_CANCEL = 'UPLOAD_CANCEL';

export default {
  namespaced: true,
  state: {
    files: [],
    cancelToken: null,
  },
  getters: {
    files: state => state.files,
    totalCount: state => state.files.length,
    totalSize: state => state.files.reduce((total, item) => total + item.size, 0),
    unUploadFiles: state => state.files.filter(file => file.status === READY),
    unUploadCount: (state, getters) => getters.unUploadFiles.length,
    incompleteCount: state => state.files.filter(file => file.status !== SUCCESS).length,
    cancelToken: state => state.cancelToken,
  },
  actions: {
    add({ commit }, payload) {
      commit(UPLOAD_ADD, payload);
    },
    update({ commit }, payload) {
      commit(UPLOAD_UPDATE, payload);
    },
    remove({ commit }, payload) {
      commit(UPLOAD_REMOVE, payload);
    },
    clear({ commit }) {
      commit(UPLOAD_CLEAR);
    },
    setCancelToken({ commit }, payload) {
      commit(UPLOAD_CANCEL, payload);
    },
  },
  mutations: {
    [UPLOAD_ADD](state, payload) {
      state.files = [...state.files, payload];
    },
    [UPLOAD_UPDATE](state, payload) {
      state.files = state.files.map(file => (file.uid === payload.uid ? Object.assign({}, file, payload) : file));
    },
    [UPLOAD_REMOVE](state, payload) {
      state.files = state.files.filter(file => file.uid !== payload);
    },
    [UPLOAD_CLEAR](state) {
      state.files = [];
    },
    [UPLOAD_CANCEL](state, payload) {
      state.cancelToken = payload;
    },
  },
};
